import {EventEmitter, Injectable} from "@angular/core";


@Injectable({providedIn: 'root'})
export class TreeSelectService {
  resetSelection = new EventEmitter();
  expandItem = new EventEmitter();
}
